import { handleOnChangeDataOwnerRenewal } from './helpers';
import {
  getOwnerData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const onOwnerLastNameChange = {
  onOwnerLastNameChange(initialRun?: boolean) {
    const { lastName } = getOwnerData();
    const { mainOwner } = getQuotation();

    const previousLastName = mainOwner?.lastName || '';

    if (checkHasDataChangedForRenewal(lastName, previousLastName)) {
      handleOnChangeDataOwnerRenewal(initialRun);
    }

    setMainOwnerSelectionDictionary();
  },
};

export default onOwnerLastNameChange;
